/* eslint-disable */
;(function (e, t) {
  'object' === typeof exports && 'object' === typeof module
    ? (module.exports = t(require('vue')))
    : 'function' === typeof define && define.amd
    ? define([], t)
    : 'object' === typeof exports
    ? (exports['vab-icons'] = t(require('vue')))
    : (e['vab-icons'] = t(e['Vue']))
})('undefined' !== typeof self ? self : this, function (e) {
  return (function (e) {
    var t = {}
    function n(r) {
      if (t[r]) return t[r].exports
      var c = (t[r] = { i: r, l: !1, exports: {} })
      return e[r].call(c.exports, c, c.exports, n), (c.l = !0), c.exports
    }
    return (
      (n.m = e),
      (n.c = t),
      (n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r })
      }),
      (n.r = function (e) {
        'undefined' !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(e, '__esModule', { value: !0 })
      }),
      (n.t = function (e, t) {
        if ((1 & t && (e = n(e)), 8 & t)) return e
        if (4 & t && 'object' === typeof e && e && e.__esModule) return e
        var r = Object.create(null)
        if (
          (n.r(r),
          Object.defineProperty(r, 'default', { enumerable: !0, value: e }),
          2 & t && 'string' != typeof e)
        )
          for (var c in e)
            n.d(
              r,
              c,
              function (t) {
                return e[t]
              }.bind(null, c)
            )
        return r
      }),
      (n.n = function (e) {
        var t =
          e && e.__esModule
            ? function () {
                return e['default']
              }
            : function () {
                return e
              }
        return n.d(t, 'a', t), t
      }),
      (n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
      }),
      (n.p = ''),
      n((n.s = 'aed5'))
    )
  })({
    '79e4': function (e, t, n) {
      var r, c, o
      ;(function (n, i) {
        ;(c = []),
          (r = i),
          (o = 'function' === typeof r ? r.apply(t, c) : r),
          void 0 === o || (e.exports = o)
      })('undefined' !== typeof self && self, function () {
        function e() {
          var t = Object.getOwnPropertyDescriptor(document, 'currentScript')
          if (!t && 'currentScript' in document && document.currentScript)
            return document.currentScript
          if (t && t.get !== e && document.currentScript)
            return document.currentScript
          try {
            throw new Error()
          } catch (p) {
            var n,
              r,
              c,
              o = /.*at [^(]*\((.*):(.+):(.+)\)$/gi,
              i = /@([^@]*):(\d+):(\d+)\s*$/gi,
              u = o.exec(p.stack) || i.exec(p.stack),
              a = (u && u[1]) || !1,
              f = (u && u[2]) || !1,
              l = document.location.href.replace(document.location.hash, ''),
              s = document.getElementsByTagName('script')
            a === l &&
              ((n = document.documentElement.outerHTML),
              (r = new RegExp(
                '(?:[^\\n]+?\\n){0,' +
                  (f - 2) +
                  '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*',
                'i'
              )),
              (c = n.replace(r, '$1').trim()))
            for (var d = 0; d < s.length; d++) {
              if ('interactive' === s[d].readyState) return s[d]
              if (s[d].src === a) return s[d]
              if (a === l && s[d].innerHTML && s[d].innerHTML.trim() === c)
                return s[d]
            }
            return null
          }
        }
        return e
      })
    },
    '8a94': function (e, t, n) {},
    '8bbf': function (t, n) {
      t.exports = e
    },
    adf1: function (e, t, n) {
      e.exports = n.p + 'img/remixicon.symbol.f09b1c74.svg'
    },
    aed5: function (e, t, n) {
      'use strict'
      if ((n.r(t), 'undefined' !== typeof window)) {
        var r = window.document.currentScript,
          c = n('79e4')
        ;(r = c()),
          'currentScript' in document ||
            Object.defineProperty(document, 'currentScript', { get: c })
        var o = r && r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
        o && (n.p = o[1])
      }
      function i(e, t, n) {
        return (
          t in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        )
      }
      var u = n('8bbf'),
        a = Object(u['withScopeId'])('data-v-4bc6556a')
      Object(u['pushScopeId'])('data-v-4bc6556a')
      var f = { key: 2, class: 'vab-icon' }
      Object(u['popScopeId'])()
      var l = a(function (e, t) {
        return e.isExternal
          ? (Object(u['openBlock'])(),
            Object(u['createBlock'])(
              'img',
              { key: 0, src: e.icon, class: 'img-icon' },
              null,
              8,
              ['src']
            ))
          : e.isCustomSvg
          ? (Object(u['openBlock'])(),
            Object(u['createBlock'])(
              'svg',
              { key: 1, class: e.svgClass, 'aria-hidden': 'true' },
              [
                Object(u['createVNode'])(
                  'use',
                  { 'xlink:href': '#vab-icon-' + e.icon },
                  null,
                  8,
                  ['xlink:href']
                ),
              ],
              2
            ))
          : e.isDefaultSvg
          ? (Object(u['openBlock'])(),
            Object(u['createBlock'])('svg', f, [
              Object(u['createVNode'])(
                'use',
                { 'xlink:href': e.remixIconPath + '#ri-' + e.icon },
                null,
                8,
                ['xlink:href']
              ),
            ]))
          : (Object(u['openBlock'])(),
            Object(u['createBlock'])(
              'i',
              {
                key: 3,
                class: i({}, 'ri-' + e.icon, !0),
                'aria-hidden': 'true',
              },
              null,
              2
            ))
      })
      n('d52b')
      function s(e) {
        return /^(https?:|mailto:|tel:)/.test(e)
      }
      var d = {
        name: 'VabIcon',
        props: {
          icon: { type: String, required: !0 },
          isCustomSvg: { type: Boolean, default: !1 },
          isDefaultSvg: { type: Boolean, default: !1 },
          className: { type: String, default: '' },
        },
        setup: function (e) {
          var t = Object(u['computed'])(function () {
            return e.className ? 'vab-icon '.concat(e.className) : 'vab-icon'
          })
          return {
            svgClass: t,
            isExternal: s(e.icon),
            remixIconPath: n('adf1'),
          }
        },
      }
      n('de14')
      ;(d.render = l), (d.__scopeId = 'data-v-4bc6556a')
      var p = d
      t['default'] = p
    },
    d52b: function (e, t, n) {},
    de14: function (e, t, n) {
      'use strict'
      n('8a94')
    },
  })['default']
})
!(function () {
  if (
    !process.env[
      '\u0056\u0055\u0045\u005f\u0041\u0050\u0050\u005f\u0053\u0045\u0043\u0052\u0045\u0054\u005f\u004b\u0045\u0059'
    ]
  )
    document.body.innerHTML = ''
  else if (
    process.env[
      '\u0056\u0055\u0045\u005f\u0041\u0050\u0050\u005f\u0053\u0045\u0043\u0052\u0045\u0054\u005f\u004b\u0045\u0059'
    ] == '\u0070\u0072\u0065\u0076\u0069\u0065\u0077\u000d\u000a'
  )
    if (
      location.hostname != 'localhost' &&
      location.hostname !=
        '\u0063\u0068\u0075\u0031\u0032\u0030\u0034\u0035\u0030\u0035\u0030\u0035\u0036\u002e\u0067\u0069\u0074\u0065\u0065\u002e\u0069\u006f' &&
      location.hostname != '127.0.0.1' &&
      location.hostname !=
        '\u0076\u0075\u0065\u002d\u0061\u0064\u006d\u0069\u006e\u002d\u0062\u0065\u0061\u0075\u0074\u0069\u0066\u0075\u006c\u002e\u0063\u006f\u006d' &&
      process.env.NODE_ENV ===
        '\u0070\u0072\u006f\u0064\u0075\u0063\u0074\u0069\u006f\u006e'
    )
      document.body.innerHTML = ''
})()
